export const DASHBOARD_CARD_VISIBILITY_STORAGE_KEY = 'descarga-dashboard-card-visibility-v1';
export const DASHBOARD_TIMER_SETTINGS_STORAGE_KEY = 'descarga-dashboard-timer-settings-v1';
export const DASHBOARD_TIMER_MIN_MINUTES = 1;
export const DASHBOARD_TIMER_DEFAULT_MINUTES = 5;

export const dashboardCardVisibilityOptions = [
  {
    id: 'lojasComMaisAtrasos',
    label: 'Lojas com mais atraso de descarga',
    group: 'top',
    variant: 'featured'
  },
  {
    id: 'mediaTempoEspera',
    label: 'Media de espera',
    group: 'top',
    variant: 'compact'
  },
  {
    id: 'atrasoDescarga',
    label: 'Atraso de descarga',
    group: 'top',
    variant: 'compact'
  },
  {
    id: 'chegadasForaJanela',
    label: 'Chegadas fora da janela',
    group: 'janela',
    span: 3
  },
  {
    id: 'tempoMedioForaJanela',
    label: 'Tempo medio fora da janela',
    group: 'janela',
    span: 3
  },
  {
    id: 'lojasForaJanela',
    label: 'Lojas com mais chegadas fora da janela',
    group: 'janela',
    span: 6
  },
  {
    id: 'rankingMediaTempoLoja',
    label: 'Ranking tempo medio de descarga por loja',
    group: 'full'
  },
  {
    id: 'rankingMediaTempoLojaTabela',
    label: 'Tabela ranking tempo medio de descarga por loja',
    group: 'full'
  },
  {
    id: 'totalCargasUltimosDias',
    label: 'Total de cargas',
    group: 'full'
  }
];

export const getDefaultDashboardCardVisibility = (options = dashboardCardVisibilityOptions) => options.reduce((acc, option) => ({
  ...acc,
  [option.id]: true
}), {});

export const defaultDashboardCardVisibility = getDefaultDashboardCardVisibility();

export const normalizeDashboardCardVisibility = (
  value = {},
  options = dashboardCardVisibilityOptions
) => options.reduce((acc, option) => ({
  ...acc,
  [option.id]: typeof value?.[option.id] === 'boolean' ? value[option.id] : true
}), {});

export const normalizeDashboardTimerSettings = (value = {}) => {
  const parsedMinutes = Number(value?.intervalMinutes);
  const intervalMinutes = Number.isFinite(parsedMinutes)
    ? Math.max(DASHBOARD_TIMER_MIN_MINUTES, Math.floor(parsedMinutes))
    : DASHBOARD_TIMER_DEFAULT_MINUTES;

  return {
    intervalMinutes
  };
};
